import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import moment from 'moment-timezone';

import { actions } from '../../SuperUser/Report/redux/actions';
import { graphContainer } from './graphContainers';
import { ColorPalette } from '../DashboardColorPalettes';
import { getProgramDisplayName } from '../../../utils/cmsPrograms';
import GenericCategoryGraph, { chartTypeEnum } from '../../../components/Graphs/GenericCategoryGraph';
import Strings from '../../../Strings';

function ProgramDistribution(props) {
  const { colorPalette, graphType, refreshTimestamp, orgIds } = props;
  const [data, setData] = React.useState();

  React.useEffect(() => {
    let request = {};
    request.startTimestamp = moment()
      .subtract(30, 'days')
      .startOf('day')
      .format();
    request.endTimestamp = moment()
      .subtract(1, 'days')
      .endOf('day')
      .format();
    request.orgId = orgIds && orgIds.length > 0 ? orgIds : undefined;

    // Use cached dispatch to avoid duplicate API calls
    import('../../../utils/apiCache').then(({ cachedDispatch }) => {
      cachedDispatch(
        'program_statistics',
        request,
        () => props.getProgramStatistics(request),
        60000, // Cache for 1 minute
      ).then(resp => {
        setData([
          {
            program: getProgramDisplayName('RTM', 'RTMRespiratory'),
            count: resp.response.RTM?.total_patients_per_subprogram?.RTMRespiratory || 0,
          },
          {
            program: getProgramDisplayName('RTM', 'RTMMusculoskeletal'),
            count: resp.response.RTM?.total_patients_per_subprogram?.RTMMusculoskeletal || 0,
          },
          {
            program: getProgramDisplayName('RTM', 'RTMBehavioralHealth'),
            count: resp.response.RTM?.total_patients_per_subprogram?.RTMBehavioralHealth || 0,
          },
          { program: getProgramDisplayName('RPM'), count: resp.response.RPM?.total_patients_per_subprogram?.RPM || 0 },
        ]);
      });
    });
  }, [refreshTimestamp, orgIds]);

  const dataSeries = [
    {
      name: 'Program',
      color: colorPalette?.interpolate(0.73),
      selector: item => item.count,
    },
  ];

  return graphContainer(
    <GenericCategoryGraph
      graphData={data}
      hasBorder
      forceCondensed
      xAxisTopPosition={false}
      yAxisUnit=""
      tooltipTitle={Strings.program}
      dataSeries={dataSeries}
      categorySelector={item => item.program}
      hasReferenceAreas
      graphType={graphType}
      colorPalette={colorPalette}
      yAxisWidth={graphType === chartTypeEnum.horizontalBar ? 150 : 40}
    />,
    'Enrollments',
  );
}

ProgramDistribution.widgetId = 'ProgramDistributionWidget';

ProgramDistribution.propTypes = {
  getProgramStatistics: PropTypes.func,
  colorPalette: PropTypes.object,
  graphType: PropTypes.string,
  refreshTimestamp: PropTypes.number,
  orgIds: PropTypes.arrayOf(PropTypes.string),
};

const mapStateToProps = state => {
  return {
    colorPalette:
      ColorPalette[state.dashboardState.configuration?.allDashboards?.colorPalette] || Object.values(ColorPalette)[0],
    orgIds: state.entities?.orgFilter?.orgIds,
  };
};

const mapDispatchToProps = dispatch => ({
  getProgramStatistics: request => dispatch(actions.getProgramStatistics(request)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProgramDistribution);
